import React from 'react';
import { ClipboardListIcon, ClockIcon, PencilRulerIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, PencilRulerIcon, ClipboardListIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-150" data-mp="3m15pdzmfxgpu">
      <div className="mx-auto max-w-5xl" data-id="element-151" data-mp="njjljrfd814z">
        <SectionHeading id="pain-heading" eyebrow="Ti riconosci?" title={<>
              Insegnare è la tua passione.{' '}
              <Accent data-id="element-153" data-mp="ds5gl44na94g">Preparare tutto da zero non dovrebbe essere il tuo secondo lavoro.</Accent>
            </>} data-id="element-152" data-mp="nigu9ie4rwoj" />

        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-154" data-mp="8tu7ivm6c2na">
          <p data-id="element-155" data-mp="11j1hqruzqgod">
            Sei una professionista Lash & Brow, ma organizzare le lezioni richiede sempre più tempo?
          </p>
          <p data-id="element-156" data-mp="3beanhx2e163k">
            Devi scegliere gli argomenti, creare esercizi, preparare dimostrazioni e trovare un modo per
            valutare le allieve.
          </p>
          <p data-id="element-157" data-mp="31ng4r2ocoomv">E quando finalmente hai tutto pronto, è già ora di preparare il corso successivo.</p>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-3" role="list" data-id="element-158" data-mp="36lznyvbk7mbj">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex flex-col rounded-[20px] bg-brand-ivory p-6" data-id="element-159" data-mp="2wod6q26sfioe" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand-blush" data-id="element-160" data-mp="2wm0ix8ecme3f">
                  <Icon className="h-5 w-5 text-brand-rosewood" strokeWidth={1.5} aria-hidden="true" data-id="element-161" data-mp="2nneyt8t8ar0j" />
                </span>
                <span className="mt-4 block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-162" data-mp="gy8se40wkdaj">
                  {pain.title}
                </span>
                <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-163" data-mp="kev8drx3aj0a">{pain.text}</span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-164" data-mp="fi4o0se95192">
          Non ti manca la competenza. <Accent data-id="element-165" data-mp="5jf998hnjwx1">Ti serve un sistema didattico organizzato.</Accent>
        </p>
      </div>
    </section>;
}